import type { SidebarNav } from '@elva/ui';

export const SIDEBAR_NAV: SidebarNav[] = [
  { key: 'dashboard', icon: 'grid', label: 'Dashboard' },
  { key: 'live-feed', icon: 'activity', label: 'Live feed', sparkle: true, live: true },
  { key: 'warm-transfer', icon: 'phone', label: 'Warm transfer' },
  { key: 'reports', icon: 'bars', label: 'Reports' },
  { key: 'call-logs', icon: 'book', label: 'Call logs' },
  { key: 'settings', icon: 'cog', label: 'Settings' },
];

export const NAV_PATHS: Record<string, string> = {
  dashboard: '/',
  'live-feed': '/live-feed',
  'warm-transfer': '/warm-transfer',
  reports: '/reports',
  'call-logs': '/call-logs',
  settings: '/settings',
};

export function getNavKeyFromPath(pathname: string): string {
  if (pathname.startsWith('/live-feed')) return 'live-feed';
  if (pathname.startsWith('/warm-transfer')) return 'warm-transfer';
  if (pathname.startsWith('/reports')) return 'reports';
  if (pathname.startsWith('/call-logs')) return 'call-logs';
  if (pathname.startsWith('/settings')) return 'settings';
  return 'dashboard';
}
